import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add resource hints to improve performance
const createResourceHint = (rel, href, as = null, type = null, crossOrigin = null) => {
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  if (as) link.as = as;
  if (type) link.type = type;
  if (crossOrigin) link.crossOrigin = crossOrigin;
  return link;
};
// DNS prefetch for external domains
document.head.appendChild(createResourceHint('dns-prefetch', 'https://fonts.gstatic.com'));
document.head.appendChild(createResourceHint('dns-prefetch', 'https://uploadthingy.s3.us-west-1.amazonaws.com'));
document.head.appendChild(createResourceHint('dns-prefetch', 'https://www.googletagmanager.com'));
document.head.appendChild(createResourceHint('dns-prefetch', 'https://connect.facebook.net'));
document.head.appendChild(createResourceHint('dns-prefetch', 'https://irelief.us'));
// Preconnect to critical origins
document.head.appendChild(createResourceHint('preconnect', 'https://fonts.gstatic.com', null, null, 'anonymous'));
document.head.appendChild(createResourceHint('preconnect', 'https://uploadthingy.s3.us-west-1.amazonaws.com', null, null, 'anonymous'));
// Preload critical fonts with high priority
const fontPreloadLinks = [{
  href: 'https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2',
  weight: '400'
}, {
  href: 'https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2',
  weight: '500'
}, {
  href: 'https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2',
  weight: '600'
}, {
  href: 'https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2',
  weight: '700'
}];
// Create font preload links
fontPreloadLinks.forEach(font => {
  document.head.appendChild(createResourceHint('preload', font.href, 'font', 'font/woff2', 'anonymous'));
});
// Add optimized font-face declarations with font-display: swap
const fontStyle = document.createElement('style');
fontStyle.textContent = `
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/inter/v12/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
`;
document.head.appendChild(fontStyle);
// Preload hero image for faster LCP
document.head.appendChild(createResourceHint('preload', 'https://uploadthingy.s3.us-west-1.amazonaws.com/aFC8BsJhF5r9qvndnF3JxE/Gemini_Generated_Image_hu0dtkhu0dtkhu0d_%281%29.webp', 'image', 'image/webp'));
// Preload critical CSS
const criticalCSS = document.createElement('style');
criticalCSS.textContent = `
  /* Critical CSS for above-the-fold content */
  body { font-family: 'Inter', sans-serif; margin: 0; }
  .bg-slate-50 { background-color: rgb(248 250 252); }
  .min-h-screen { min-height: 100vh; }
  .w-full { width: 100%; }
  .font-sans { font-family: 'Inter', sans-serif; }
  .text-slate-800 { color: rgb(30 41 59); }
  .fixed { position: fixed; }
  .top-0 { top: 0; }
  .left-0 { left: 0; }
  .right-0 { right: 0; }
  .h-1 { height: 0.25rem; }
  .z-50 { z-index: 50; }
  .bg-transparent { background-color: transparent; }
  .bg-[#0EA5B7] { background-color: #0EA5B7; }
  .relative { position: relative; }
  .pt-16 { padding-top: 4rem; }
  .pb-20 { padding-bottom: 5rem; }
  .overflow-hidden { overflow: hidden; }
  .absolute { position: absolute; }
  .inset-0 { top: 0; right: 0; bottom: 0; left: 0; }
  .object-cover { object-fit: cover; }
  .object-center { object-position: center; }
`;
document.head.insertBefore(criticalCSS, document.head.firstChild);
// Add a lightweight script to prevent layout shifts during loading
const layoutStabilityScript = document.createElement('script');
layoutStabilityScript.textContent = `
  // Reserve space for key elements to prevent layout shifts
  document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
  window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
  });
`;
document.head.appendChild(layoutStabilityScript);
// Render the app with a microtask to allow browser to process critical resources first
setTimeout(() => {
  render(<App data-id="element-573" />, document.getElementById('root'));
}, 0);